import React, { useEffect } from "react";
import { EEA2Service } from "../../../../Component/Api/EmploymentEquity/WorkforceProfile_EEA2/EEA2Service";
import { DataTable } from "../../../../Component/Common/Components/DataTable/DataTable";
import { IndividualDrilldownSummaryDto } from "../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/IndividualDrilldownSummaryDto";
import { SkillsDevelopmentIndividual } from "../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/SkillsDevelopment";
import { EntriesPerPage } from "../../../../Component/Model/Table/Table";
import { defaultObject } from "../../../../Helpers/typescriptHelper";
import { IndividualDrilldownMapper } from "../../../Common/EEA2/IndividualDrilldownCommon";
import { IndividualModal } from "../../../Common/Individual/IndividualModal";

interface IProps {
    scorecardId: string;
    occupationId?: number;
    raceId?: number;
    genderId?: number;
    isPermanent?: boolean;
}

export const SkillsDevelopmentDrilldown = (props: IProps) => {

    const [individualData, setIndividualData] = React.useState<IndividualDrilldownSummaryDto[]>(defaultObject);
    const [entriesPerPage, setEntriesPerPage] = React.useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = React.useState<number>(1);
    const [filteredItemsCount, setFilteredItemsCount] = React.useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = React.useState<number>(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [searchValue, setSearchValue] = React.useState<string>();

    const [selectedIndividualId, setSelectedIndividualId] = React.useState<number>(0);
    const [showIndividualModal, setShowIndividualModal] = React.useState<boolean>(false);

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const individualsSearchRequest: SkillsDevelopmentIndividual.Request = {
        ScorecardId: props.scorecardId,
        GenderId: props.genderId,
        IsPermanent: props.isPermanent,
        OccupationalLevelId: props.occupationId,
        RaceId: props.raceId,
        PageNumber: pageNumber,
        PageSize: entriesPerPage.defaultValue as number,
        SearchValue: searchValue
    };

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let searchResult = await EEA2Service.GetSkillsDevelopmentIndividuals(individualsSearchRequest);
            if (searchResult.data) {
                setIndividualData(searchResult.data.results);
                setFilteredItemsCount(searchResult.data.filteredItemsCount);
                setTotalItemsCount(searchResult.data.totalItemsCount);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }

    };

    useEffect(() => {
        fetchData();
    }, [entriesPerPage, pageNumber, searchValue]); // eslint-disable-line react-hooks/exhaustive-deps

    const onEdit = (id: number) => {
        setSelectedIndividualId(id);
        setShowIndividualModal(true);
    }

    const closeIndividualModal = () => {
        setShowIndividualModal(false);
        setSelectedIndividualId(0);
    }

    const movementsDrilldownTableData = IndividualDrilldownMapper(individualData, onEdit);
    return (
        <>
            <div style={{ marginTop: "-32px" }}>
                <DataTable
                    table={movementsDrilldownTableData}
                    entriesPerPage={entriesPerPage}
                    pageNumber={pageNumber}
                    filteredItemsCount={filteredItemsCount}
                    totalItemsCount={totalItemsCount}
                    entriesPerPageChanged={entriesPerPageChanged}
                    pageNumberChanged={pageNumberChanged}
                    isLoading={isLoading}
                    searchValueChanged={searchValueChanged}
                    canSearch={true}
                ></DataTable>
            </div>
            {showIndividualModal && <IndividualModal showIndividualModal={showIndividualModal} closeIndividualModal={closeIndividualModal} scorecardId={props.scorecardId} id={selectedIndividualId} />}
        </>
    )
}
